import { DecreeMultipleSelect } from "@/components/form-control/DecreeMultipleSelect";
import { DecreeCategory } from "@/types/gql/graphql";
import * as React from "react";
import { CurbZoneMultiplePromptProps } from "./curb-zone-prompt.type";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { curbZoneMultipleSchema, CurbZoneMultipleFormValues, parkingAngleOptions } from "./curb-zone.const";

import { Button } from "@/components/ui/button";
import { DropdownSelect } from "components/form-control";
import { Input } from "@/components/ui/input";
import { PolicyView } from "./policy-view";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { zodResolver } from "@hookform/resolvers/zod";

export const CurbZoneMultiplePrompt = ({
  numberOfParking,
  cancel,
  handleEditMultipleCurbZone,
}: CurbZoneMultiplePromptProps) => {
  const [curbPolicies, setCurbPolicies] = useState<string[]>([]);

  const form = useForm({
    resolver: zodResolver(curbZoneMultipleSchema),
    mode: "all",
  });

  const onSubmit = (data: CurbZoneMultipleFormValues) => {
    handleEditMultipleCurbZone({
      ...data,
      curbPolicyIds: curbPolicies,
      decreeIds: data.selectedDecrees?.map((decree) => decree.value),
    });
  };

  return (
    <Dialog open>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit multiple Curb Zone</DialogTitle>
          <DialogDescription>{`Currently selecting ${numberOfParking} Curb Zones`}</DialogDescription>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
            <PolicyView curbPolicies={curbPolicies} setCurbPolicies={setCurbPolicies} />

            <FormField
              control={form.control}
              name="parkingAngle"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Forme</FormLabel>
                  <FormControl>
                    <DropdownSelect
                      options={parkingAngleOptions}
                      value={field.value ?? undefined}
                      onValueChange={(value) => field.onChange(value)}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="streetName"
              render={({ field: { onChange, value } }) => (
                <FormItem>
                  <FormLabel>Nom voie</FormLabel>
                  <FormControl>
                    <Input value={value ?? undefined} onChange={onChange} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="width"
              render={({ field: { onChange, value } }) => (
                <FormItem>
                  <FormLabel>Largeur</FormLabel>
                  <FormControl>
                    <Input
                      type="number"
                      placeholder="Largeur"
                      value={value ?? undefined}
                      onChange={(e) => onChange(Number(e.target.value))}
                      min={0}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <DecreeMultipleSelect categories={[DecreeCategory.Permanent]} />

            <DialogFooter className="sm:justify-between">
              <Button type="button" variant="secondary" onClick={cancel}>
                Cancel
              </Button>
              <Button type="submit">Save</Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
